import React, { useState } from 'react';
import '../styles/products.css';
import racketsImg from '../assets/racket-card.png';
import shuttleImg from '../assets/shuttle-card.png';
import stringingImg from '../assets/stringing-card.png';
import accessoriesImg from '../assets/accessories-card.png';
import config from '../config';

export default function Products() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState('');

  const validateEmail = (email) => {
    if (!email) {
      setEmailError('');
      return true;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      return false;
    }
    
    // Check for common typos in domain
    const typos = {
      'gmial.com': 'gmail.com',
      'gmai.com': 'gmail.com',
      'yahooo.com': 'yahoo.com',
      'yaho.com': 'yahoo.com',
      'hotmial.com': 'hotmail.com',
      'outlok.com': 'outlook.com'
    };
    
    const domain = email.split('@')[1]?.toLowerCase();
    
    if (domain && typos[domain]) {
      setEmailError(`Did you mean ${typos[domain]}?`);
      return false;
    }
    
    setEmailError('');
    return true;
  };

  const handleNotifyClick = async () => {
    if (!email.trim()) {
      setEmailError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`https://formspree.io/f/${config.formspree.notificationFormId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email })
      });
      
      if (response.ok) {
        alert('Thank you! We\'ll notify you when we launch.');
        setEmail('');
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
      alert('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <section id="products-section" className="products-section">
        <h2 className="products-title">
          What <span className="highlight">We Offer</span>
        </h2>
        <div className="products-container">
          <div className="product-card">
            <img src={racketsImg} alt="Rackets" className="product-image" />
            <h3>Rackets</h3>
          </div>
          <div className="product-card">
            <img src={shuttleImg} alt="Shuttles" className="product-image" />
            <h3>Shuttles</h3>
          </div>
          <div className="product-card">
            <img src={stringingImg} alt="Stringing Services" className="product-image" />
            <h3>Stringing</h3>
          </div>
          <div className="product-card">
            <img src={accessoriesImg} alt="Accessories" className="product-image" />
            <h3>Accessories</h3>
          </div>
        </div>
      </section>

      <section id="about" className="about-section">
        <div className="about-content">
          <h2 className="about-title">
            Who <span className="highlight">We Are</span>
          </h2>
          <p>
            We're badminton players who got tired of the confusing choices and inconsistent quality in the UK market. Our products are carefully curated and chosen based on real playing experience.
          </p>
          <p>
            <strong>Our mission:</strong> help UK players find reliable equipment without the guesswork. No sponsored recommendations—just honest advice from people who actually play the game.
          </p>
        </div>
      </section>
      
      <section className="email-signup">
        <h2>Be the first to know when we launch.</h2>
        <div className="email-form">
          <input 
            type="email" 
            placeholder="Enter your email address" 
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError('');
            }}
            onBlur={() => validateEmail(email)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleNotifyClick();
              }
            }}
            className={emailError ? 'error' : ''}
          />
          {emailError && <span className="error-message">{emailError}</span>}
          <button 
            className="notify-btn" 
            onClick={handleNotifyClick}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Notify Me'}
          </button>
        </div>
        <p className="email-disclaimer">We'll email you once when we go live. No spam.</p>
      </section>
    </>
  );
}
